export const QUERIES = {
  SIGN_IN: 'QUERY_SIGN_IN',
  QUERY_STUDENT_AUTH: 'QUERY_STUDENT_AUTH',
  QUERY_GET_REQUEST_BY_ID: 'QUERY_GET_REQUEST_BY_ID',
  QUERY_GET_REQUESTS_MANAGER_PANEL: 'QUERY_GET_REQUESTS_MANAGER_PANEL',
  QUERY_GET_REQUESTS_EXTERNAL_TRANSFER: 'QUERY_GET_REQUESTS_EXTERNAL_TRANSFER',
  QUERY_GET_REQUESTS_CHANGE_OF_MAJOR: 'QUERY_GET_REQUESTS_CHANGE_OF_MAJOR',
  QUERY_GET_REQUESTS_MY_REVIEWS: 'QUERY_GET_REQUESTS_MY_REVIEWS',
  QUERY_GET_REQUESTS_ALL_MY_REVIEWS: 'QUERY_GET_REQUESTS_ALL_MY_REVIEWS',
  QUERY_GET_REQUESTS_CREDIT_TRANSFER: 'QUERY_GET_REQUESTS_CREDIT_TRANSFER',
  QUERY_GET_REQUESTS_ALL_MY_REVIEWS_CHANGE_OF_MAJOR:
    'QUERY_GET_REQUESTS_ALL_MY_REVIEWS_CHANGE_OF_MAJOR',
  QUERY_GET_COURSES_BY_CURRICULUM: 'QUERY_GET_COURSES_BY_CURRICULUM',
  QUERY_GET_COURSES_BY_CURRICULUM_PREVIEW:
    'QUERY_GET_COURSES_BY_CURRICULUM_PREVIEW',
  QUERY_GET_PREVIOUS_EDUCATION_COURSES_BY_REQUEST:
    'QUERY_GET_PREVIOUS_EDUCATION_COURSES_BY_REQUEST',
  QUERY_GET_REQUESTS_EXTERNAL_TRANSFER_MANAGER_PANEL_KPI:
    'QUERY_GET_REQUESTS_EXTERNAL_TRANSFER_MANAGER_PANEL_KPI',
  QUERY_GET_REQUESTS_CHANGE_OF_MAJOR_MANAGER_PANEL_KPI:
    'QUERY_GET_REQUESTS_CHANGE_OF_MAJOR_MANAGER_PANEL_KPI',
  QUERY_GET_REQUESTS_CREDIT_TRANSFER_MANAGER_PANEL_KPI:
    'QUERY_GET_REQUESTS_CREDIT_TRANSFER_MANAGER_PANEL_KPI',
  QUERY_GET_EXPIRED_TOKEN_BY_ID: 'QUERY_GET_EXPIRED_TOKEN_BY_ID',

  QUERY_GET_REQUESTS_MY_REVIEWS_CREDIT_TRANSFER:
    'QUERY_GET_REQUESTS_MY_REVIEWS_CREDIT_TRANSFER',
  QUERY_GET_REQUESTS_MY_REVIEWS_EXTERNAL_TRANSFER:
    'QUERY_GET_REQUESTS_MY_REVIEWS_EXTERNAL_TRANSFER',
  QUERY_GET_MANAGER_PANEL_KPIS: 'QUERY_GET_MANAGER_PANEL_KPIS',
  QUERY_GET_PREVIOUS_EDUCATIONS: 'QUERY_GET_PREVIOUS_EDUCATIONS',
  QUERY_GET_DESIRED_EDUCATIONS: 'QUERY_GET_DESIRED_EDUCATIONS',
  QUERY_GET_PREVIOUS_EDUCATIONAL_INSTITUTIONS:
    'QUERY_GET_PREVIOUS_EDUCATIONAL_INSTITUTIONS',
  QUERY_GET_ALL_REQUESTS_VIEW_MORE: 'QUERY_GET_ALL_REQUESTS_VIEW_MORE',
  QUERY_GET_DISCIPLINES: 'QUERY_GET_DISCIPLINES',
  QUERY_GET_CURRICULUMS: 'QUERY_GET_CURRICULUMS',

  QUERY_POST_GRANT_EXTERNAL_TRANSFER: 'QUERY_POST_GRANT_EXTERNAL_TRANSFER',
  QUERY_POST_DENY_EXTERNAL_TRANSFER: 'QUERY_POST_DENY_EXTERNAL_TRANSFER',
  QUERY_POST_GRANT_CREDIT_TRANSFER: 'QUERY_POST_GRANT_CREDIT_TRANSFER',
  QUERY_POST_DENY_CREDIT_TRANSFER: 'QUERY_POST_DENY_CREDIT_TRANSFER',

  QUERY_POST_GRANT_CHANGE_OF_MAJOR: 'QUERY_POST_GRANT_CHANGE_OF_MAJOR',
  QUERY_POST_DENY_CHANGE_OF_MAJOR: 'QUERY_POST_DENY_CHANGE_OF_MAJOR',

  QUERY_PATCH_START_REQUEST_REVIEW: 'QUERY_PATCH_START_REQUEST_REVIEW',
  QUERY_GET_STUDENT_REQUESTS: 'QUERY_GET_STUDENT_REQUESTS',

  QUERY_GET_STUDENT_DESIRED_EDUCATION_COURSES_BY_REQUEST:
    'QUERY_GET_STUDENT_DESIRED_EDUCATION_COURSES_BY_REQUEST',
  QUERY_GET_STUDENT_OPEN_REQUEST_ELIGIBILITY:
    'QUERY_GET_STUDENT_OPEN_REQUEST_ELIGIBILITY'
}
